import { c as _c } from "react/compiler-runtime";
import { IcoBuilding24, IcoFootprint40 } from '@onefootprint/icons';
type MergedLogosProps = {
  tenantLogoUrl?: string;
  tenantName: string;
};
const MergedLogos = t0 => {
  const $ = _c(6);
  const {
    tenantLogoUrl,
    tenantName
  } = t0;
  let t1;
  if ($[0] !== tenantLogoUrl || $[1] !== tenantName) {
    t1 = <div className="size-16 flex items-center justify-center z-0 bg-primary rounded-full p-1 border border-tertiary">{tenantLogoUrl ? <img alt={`${tenantName} logo`} src={tenantLogoUrl} width={128} height={128} className="rounded-full object-cover" /> : <div className="size-full flex items-center justify-center bg-secondary rounded-full"><IcoBuilding24 color="primary" /></div>}</div>;
    $[0] = tenantLogoUrl;
    $[1] = tenantName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="-ml-4 z-1 bg-primary rounded-full p-1"><div className="size-16 flex items-center justify-center bg-quinary rounded-full"><IcoFootprint40 color="primary" /></div></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="flex flex-row items-center">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default MergedLogos;